import dayjs from 'dayjs'
import * as Yup from 'yup'

import { COUNTRIES, GENDERS } from 'constants/models'

const schema = {
  firstName: Yup.string()
    .max(50, 'First Name must not exceed 50 characters')
    .required('First Name is required'),
  lastName: Yup.string()
    .max(50, 'Last Name must not exceed 50 characters')
    .required('Last Name is required'),
  birthdate: Yup.mixed()
    .required('Birthdate is required')
    .test(
      'validate-format',
      'Birthdate must be valid date in format YYYY-MM-DD',
      (value) => {
        return dayjs(value as string, 'YYYY-MM-DD', true).isValid()
      },
    )
    .test('validate-future', 'Birthdate must not be a future date', (value) => {
      if (value !== undefined) return dayjs().isAfter(value as Date)
    }),
  nationality: Yup.mixed()
    .required('Nationality is required')
    .oneOf(Object.keys(COUNTRIES)),
  gender: Yup.mixed()
    .required('Gender is required')
    .oneOf(Object.keys(GENDERS)),
  address: Yup.string()
    .max(100, 'Address must not exceed 100 characters')
    .required('Address is required'),
  phoneNumber: Yup.string()
    .max(20, 'Phone must not exceed 20 characters')
    .required('Phone is required'),
}

export default schema
